module.exports = __webpack_public_path__ + "img/step-3-2-en.ea17a5bb.png";